import React, { useState, useRef, useEffect } from 'react';
import AddPersonModal from './AddPersonModal';
import UploadFileModal from './UploadFileModal';
import Modal from '../Modal';
import './buttons.js'
import ChannelCampaignModal from '../ChannelCampaigns/ChannelCampaignModal';

const EmailListTable = ({channelId, listId, createEmailButtonTitle, removeListEmailsPath, emailListPath, updateListPath, setListEmailsCount, setLastUpdatedTimestamp, addEmailPath, fetchListEmailsPath, emailListPollingPath}) => {

  const [listEmails, setListEmails] = useState(null);
  const [isPolling, setPolling] = useState(false);
  const [spinning, setSpinning] = useState(true);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!isPolling) {
      const params = new URLSearchParams(window.location.search)
      if (params.get('batch_id') !== null) {
        setInterval(()=> checkBatchProgress(params.get('batch_id'), params.get('num_existing_list_emails'), params.get('batch_size')), 3000);
        setPolling(true)
      }
    }
  }, [isPolling])

  useEffect(() => {
    fetchData()
  }, [])

  const checkBatchProgress = (batchID, numExistingListEmails, batchSize) => {
    $.ajax({
      type: 'GET',
      url: emailListPollingPath,
      data: {batch_id: batchID, num_existing_list_emails: numExistingListEmails, batch_size: batchSize},
      success: function(data) {
        if (data.completed) {
          window.location.href = emailListPath
        }
      }
    });
  }

  const fetchData = () => {
    setSpinning(true)
    $.ajax({
      type: 'GET',
      url: fetchListEmailsPath,
      success: function(data) {
        setSpinning(false)
        if (setLastUpdatedTimestamp) {
          setLastUpdatedTimestamp(data.lastUpdated)
        }
        if (setListEmailsCount) {
          setListEmailsCount(data.listEmails.length)
        }
        setListEmails(data.listEmails)
        populateTable(data.listEmails)
      }
    });
  }

  const removeListEmails = () => {
    if (confirm("Are you sure you want to delete the selected emails?")) {
      setSpinning(true)
      var channelReviewerIds = []
      $("input:checked").each(function() {
        channelReviewerIds.push($(this).data('resource-id'))
      })
      $.ajax({
        type: 'Delete',
        url: removeListEmailsPath,
        data: {list_email_ids: channelReviewerIds},
        success: function(data) {
          fetchData()
          const checkedInputs = $("input:checked");
          setChecked(checkedInputs.length > 0)
        }
      });
    }
  }

  const addEmailToList = (email, firstName, lastName) => {
    setSpinning(true)
    $.ajax({
      type: 'Post',
      url: addEmailPath,
      data: {email: email, first_name: firstName, last_name: lastName},
      success: function(data) {
        fetchData()
        const checkedInputs = $("input:checked");
        setChecked(checkedInputs.length > 0)
      }
    });
  }

  const handleFileUploadClicked = (e) => {
    e.preventDefault()
    Modal.open({
      children: <UploadFileModal updateListPath={updateListPath} />
    });
  }

  const addPersonModal = (e) => {
    e.preventDefault()
    Modal.open({
      children: <AddPersonModal addEmailToList={addEmailToList} />
    });
  }

  const setColumns = () => {
    return [
      {width: '35px'},
      {width: '70px'},
      {width: '70px'},
      {width: '70px'},
      {width: '70px'},
      {width: '70px'},
      null,
      {width: '70px'},
    ]
  }
  
  const checkboxClicked = (event) => {
    const checkedInputs = $("input:checked");
    setChecked(checkedInputs.length > 0)
  }

  const selectAllCheckboxes = (event) => {
    $('input:checkbox').prop('checked', event.target.checked);
    setChecked(event.target.checked)
  }

  const createInviteEmail = () => {
    Modal.open({
      children: <ChannelCampaignModal listId={listId} channelId={channelId} />
    });
  }

  const mapColumns = (dt, row) => {
    return (
      dt.fnAddData( [
        row.checkbox,
        row.first_name,
        row.last_name,
        row.email,
        row.specialty_name,
        row.date_added,
        row.sort_column,
        row.cureus_member ? 'Yes <i class="fa fa-check"></i>' : 'No',
      ], false)
    )
  }

  const populateTable = (listEmails) => {
    var dt = $("#list-emails-table").DataTable({
      columns: setColumns(),
      language: {
        "searchPlaceholder": "Search...",
        "search": ""
      },
      columnDefs: [
        {targets: [5], orderData: [6]},
        {targets: [6], visible: false},
        {orderable: false, targets: [0]}
      ],
      "bAutoWidth": false,
      dom: '<"row email-list-search-row"<f>>tr<"row pagination-row"<"small-8 columns pagination-details" <"pull-left"p><"pull-left"l>><"pull-right create-email-button-container"B>>',
      buttons: [
        {
          text: '<i class="fas fa-pencil-alt"></i> ' + createEmailButtonTitle,
          action: function ( e, dt, node, config ) {
            createInviteEmail()
          }
        }
      ],
      "fnDrawCallback": function(oSettings) {
        if (oSettings.fnRecordsDisplay() == 0) {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
          $(oSettings.nTableWrapper).find('.dataTables_length').hide();
          $(oSettings.nTableWrapper).find('.dataTables_info').hide();
        } else if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        } else {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
          $(oSettings.nTableWrapper).find('.dataTables_length').show();
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        }
      },
      "rowCallback": function(row) {
        row.children[0].children[0].addEventListener('click',function(e) {
          checkboxClicked(e)
        })
      }
    })
    
    if (!listEmails) {
      listEmails = []
    }
    dt.api().clear();
    for (var i = 0; i < listEmails.length; i++) {
      let row = listEmails[i];
      mapColumns(dt, row)
    }
    dt.fnSort([[1, 'desc']])
    dt.fnDraw()
  }

  if (spinning) {
    return (
      <React.Fragment>
        <div className='spinner-container'>
          <img src='https://public.cureus.com/ajax-loader.gif'/>
        </div>
      </React.Fragment>
    )
  } else if (listEmails && listEmails.length > 0) {
    return (
      <React.Fragment>
        <div>
          <a className="button add-single-btn primary" onClick={(e) => addPersonModal(e)}>+<i className='fa fa-user-friends'></i> ADD SINGLE RECIPIENT</a>
          <a className="button upload-btn secondary" onClick={(e) => handleFileUploadClicked(e)}><i className='fa fa-upload'></i> UPLOAD CSV FILE</a>
          <a className={`button delete secondary ${checked ? '' : 'hidden'}`} onClick={(e) => removeListEmails(e)}><i className='fa fa-trash-alt'></i> Delete</a>
        </div>
        <div className="list-emails-datatable-container">
          <table id="list-emails-table">
            <thead>
              <tr>
                <th><input onClick={(e) => selectAllCheckboxes(e)} type="checkbox" /></th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email Address</th>
                <th>Specialty</th>
                <th>Added</th>
                <th></th>
                <th>Confirmed Account</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </React.Fragment>
    )
  } else {
    return (
      <React.Fragment>
        <div className="empty-container text-center">
          <div>
            <i className='fa fa-user-friends'></i>
            <h3>No recipients listed</h3>
            <span>
              <a onClick={(e) => handleFileUploadClicked(e)}>Upload CSV file</a> or <a onClick={(e) => addPersonModal(e)}>add individually</a>
            </span>
          </div>
        </div>        
      </React.Fragment>
    )
  }

}

export default EmailListTable;